export default __webpack_public_path__ + "static/media/photo_shop-display-frames.869f6cd7.jpg";